import { createSlice } from "@reduxjs/toolkit";

type SidebarFilterState = {
  collapsed: boolean;
};

const initialState: SidebarFilterState = {
  collapsed: typeof window !== "undefined" ? window.innerWidth < 1024 : true
};

const sidebarFilterSlice = createSlice({
  name: "sidebarFilter",
  initialState,
  reducers: {
    closeFilter: (state) => {
      state.collapsed = true;
    },
    openFilter: (state) => {
      state.collapsed = false;
    },
    toggleFilterCollapsed: (state) => {
      state.collapsed = !state.collapsed;
    },
  },
});

export const { closeFilter, openFilter, toggleFilterCollapsed } =
    sidebarFilterSlice.actions;

export default sidebarFilterSlice.reducer;
